import { combineReducers } from 'redux';
import Issues from './Issues/reducer';
import Projects from './Projects/reducer';

export default combineReducers({
    Issues,
    Projects
});



// WEBPACK FOOTER //
// ./environments/ticketsgit/data/reducer.js